"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_theme_option_1 = require("owa-theme-option");
var appearanceSubCategory = {
    key: 'appearance',
    titleStringKey: 'optionSubcategory_appearance',
    options: [owa_theme_option_1.ThemeOption],
};
exports.default = appearanceSubCategory;
//# sourceMappingURL=appearanceSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-options-general/lib/config/appearanceSubCategory.js
// module id = 4954
// module chunks = 2